import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { getShipmentNo } from "app/services/apis/ListApi/shipmentNoList";
import Div from "@jumbo/shared/Div";
import axios from "axios";
import Swal from "sweetalert2";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  currentdate,
  dateFun,
  displayDateFun,
} from "app/utils/constants/functions";
import dayjs from "dayjs";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { getAllOutForDeliveryDispatch } from "app/redux/actions/orderAction";

const NormalOrderShipmentNoModal = ({ open, setOpen }) => {
  const [shipmentNoList, setShipmentNoList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      setShipmentNoList(await getShipmentNo());
    })();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      dispatch_shipment_no: "",
      dispatch_date: currentdate,
    },
    validationSchema: Yup.object({
      dispatch_shipment_no: Yup.string().required("Shipment No is required"),
      dispatch_date: Yup.date().required("Delivery Date is required"),
    }),
    onSubmit: async (values) => {
      try {
        const config = {
          withCredentials: true,
          headers: {
            withCredentials: true,
          },
        };

        const res = await axios.patch(
          `${process.env.REACT_APP_URL}/api/dispatch/shipment-no-ready-for-delivery`,
          {
            shipment_no: values.dispatch_shipment_no,
            order_item_delivery_date: dateFun(values.dispatch_date)
          },
          config
        );

        if (res?.status === 200) {
          Swal.fire({ icon: "success", title: `Delivered Successfully` });
          dispatch(getAllOutForDeliveryDispatch("", "", 1));
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: `${error?.response?.data?.message}` });
      } finally {
        setOpen(false)
      }
    },
  });

  const onClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ fontWeight: "700" }}>Dispatch Details</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Box sx={{ width: "50%" }}>
              <Typography variant="h5">Shipment No</Typography>
              <Autocomplete
                freeSolo
                size="small"
                options={shipmentNoList?.result || []}
                value={formik.values.dispatch_shipment_no}
                onChange={(event, value) => {
                  if (value) {
                    formik.setFieldValue("dispatch_shipment_no", value)
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="dispatch_shipment_no"
                    variant="outlined"
                    error={formik.touched.dispatch_shipment_no && Boolean(formik.errors.dispatch_shipment_no)}
                    helperText={formik.touched.dispatch_shipment_no && formik.errors.dispatch_shipment_no}
                  />
                )}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography variant="h5">Delivery Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YY"
                  // defaultValue={dayjs(currentdate)}
                  value={formik.values.dispatch_date ? dayjs(formik.values.dispatch_date) : dayjs()}
                  onChange={(value) => formik.setFieldValue("dispatch_date", value)}
                  sx={{
                    width: "100%",
                    "&.MuiTextField-root": {
                      height: "39px",
                      flexDirection: "unset",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      name="dispatch_date"
                      variant="outlined"
                      error={formik.touched.dispatch_date && Boolean(formik.errors.dispatch_date)}
                      helperText={formik.touched.dispatch_date && formik.errors.dispatch_date}
                    />
                  )}
                />
              </LocalizationProvider>
              <Typography>{formik.touched.dispatch_date && formik.errors.dispatch_date}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="primary">
            Close
          </Button>
          <Button type="submit" variant="contained" color="primary" disabled={formik?.isSubmitting} onClick={formik?.handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default NormalOrderShipmentNoModal;
